<template>
<nav class="pagination">
      <span class="page-stats">{{pagination.from}} - {{pagination.to}} de {{pagination.total}}</span>
      <a v-if="pagination.prevPage" @click="$emit('prev')" class="button is-small pagination-previous">
          Anterior
      </a>
      <a class="button is-small pagination-previous" v-else disabled>
          Anterior
      </a>

      <a v-if="pagination.nextPage" @click="$emit('next')" class="button is-small pagination-next">
          Siguiente
      </a>
      <a class="button is-small pagination-next" v-else disabled>
          Siguiente
      </a>
  </nav>
</template>
<script>
export default {
  props: ['pagination'],
}
</script>
<style>
  .pagination {
    justify-content: center;
    margin: 20px auto;
  }

  .pagination a,
  .pagination span {
    cursor: pointer;
    color: #000;
    font-family: 'Raleway', sans-serif;
    font-size: 21px;
    text-decoration: none;
    padding-right: 10px;
    text-align: center;
  }
  .pagination a {
    font-weight: 700;
  }
  .pagination span {
    font-weight: 400;
  }
  .pagination a:hover,
  .pagination span:hover {
    color: #222;
  }
  @media(max-width: 1255px) {
    .pagination a,
    .pagination span {
      font-size:16px;
    }
  }
</style>
